export default "__VITE_ASSET__147175b0__"